export default [
  {
    value: '01',
    label: '德城区',
    children: [
      {
        value: '01121',
        label: '德城区新时代文明实践中心',
        children: [
          {
            value: '011212',
            label: '二屯镇新时代文明实践所',
            children: [
              { value: '011211', label: '老渡口村新时代文明实践站' },
              { value: '0112121', label: '舜昕苑社区新时代文明实践站' },
              { value: '0112128', label: '索庄新村新时代文明实践站' }
            ]
          },
          {
            value: '011213',
            label: '广川街道新时代文明实践所',
            children: [
              { value: '011212', label: '兴文社区新时代文明实践站' },
              { value: '0112132', label: '东方家园社区新时代文明实践站' },
              { value: '0112139', label: '大东关社区新时代文明实践站' }
            ]
          },
          {
            value: '011214',
            label: '黄河涯镇新时代文明实践所',
            children: [
              { value: '011213', label: '焦庄村新时代文明实践站' },
              { value: '0112143', label: '九村新时代文明实践站' },
              { value: '01121410', label: '廿里铺新村新时代文明实践站' }
            ]
          },
          {
            value: '011215',
            label: '天衢街道新时代文明实践所',
            children: [
              { value: '011214', label: '果园社区新时代文明实践站' },
              { value: '0112154', label: '田龙社区新时代文明实践站' },
              { value: '01121511', label: '肖何庄社区新时代文明实践站' }
            ]
          },
          {
            value: '011216',
            label: '新湖街道新时代文明实践所',
            children: [
              { value: '011215', label: '城隍庙社区新时代文明实践站' },
              { value: '0112165', label: '康乐社区新时代文明实践站' },
              { value: '01121612', label: '明湖社区新时代文明实践站' }
            ]
          },
          {
            value: '011217',
            label: '运河街道新时代文明实践所',
            children: [
              { value: '011216', label: '屠屯村新时代文明实践站' },
              { value: '0112176', label: '五一村新时代文明实践站' },
              { value: '01121713', label: '西八里村新时代文明实践站' }
            ]
          },
          {
            value: '011218',
            label: '新华街道新时代文明实践所',
            children: [
              { value: '011217', label: '益德社区新时代文明实践站' },
              { value: '0112187', label: '新河社区新时代文明实践站' },
              { value: '01121814', label: '新园村新时代文明实践站' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '02',
    label: '经济技术开发区',
    children: [
      {
        value: '02132',
        label: '经济技术开发区新时代文明实践中心',
        children: [
          {
            value: '021322',
            label: '宋官屯街道新时代文明实践所',
            children: [
              { value: '021321', label: '新城社区新时代文明实践站' },
              { value: '0213221', label: '宋官屯社区新时代文明实践站' },
              { value: '0213224', label: '付庄社区新时代文明实践站' }
            ]
          },
          {
            value: '021323',
            label: '袁桥镇新时代文明实践所',
            children: [
              { value: '021322', label: '牟庄社区新时代文明实践站' },
              { value: '0213232', label: '袁桥社区新时代文明实践站' },
              { value: '0213235', label: '香坊赵社区新时代文明实践站（拆迁）' }
            ]
          },
          {
            value: '021324',
            label: '长河街道新时代文明实践所',
            children: [
              { value: '021323', label: '簸箕刘社区新时代文明实践站' },
              { value: '0213243', label: '明德社区新时代文明实践站' },
              { value: '0213246', label: '太阳城社区新时代文明实践站' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '03',
    label: '乐陵市',
    children: [
      {
        value: '03143',
        label: '乐陵市新时代文明实践中心',
        children: [
          {
            value: '031432',
            label: '大孙乡新时代文明实践所',
            children: [
              { value: '031431', label: '东升村新时代文明实践站' },
              { value: '0314321', label: '五合村新时代文明实践站' },
              { value: '03143217', label: '西兴村新时代文明实践站' }
            ]
          },
          {
            value: '031433',
            label: '丁坞镇新时代文明实践所',
            children: [
              { value: '031432', label: '张生村新时代文明实践站' },
              { value: '0314332', label: '振兴村新时代文明实践站' },
              { value: '03143318', label: '中兴村新时代文明实践站' }
            ]
          },
          {
            value: '031434',
            label: '郭家街道新时代文明实践所',
            children: [
              { value: '031433', label: '大张新村新时代文明实践站' },
              { value: '0314343', label: '郭家新村新时代文明实践站' },
              { value: '03143419', label: '华亿村新时代文明实践站' }
            ]
          },
          {
            value: '031435',
            label: '花园镇新时代文明实践所',
            children: [
              { value: '031434', label: '大顾新村新时代文明实践站' },
              { value: '0314354', label: '大韩新村新时代文明实践站' },
              { value: '03143520', label: '五店村新时代文明实践站' }
            ]
          },
          {
            value: '031436',
            label: '化楼镇新时代文明实践所',
            children: [
              { value: '031435', label: '丰收村新时代文明实践站' },
              { value: '0314365', label: '丰泽村新时代文明实践站' },
              { value: '03143621', label: '五合新村新时代文明实践站' }
            ]
          },
          {
            value: '031437',
            label: '黄夹镇新时代文明实践所',
            children: [
              { value: '031436', label: '安邦新村新时代文明实践站' },
              { value: '0314376', label: '富平新村新时代文明实践站' },
              { value: '03143722', label: '黄夹村新时代文明实践站' }
            ]
          },
          {
            value: '031438',
            label: '孔镇镇新时代文明实践所',
            children: [
              { value: '031437', label: '孔安村新时代文明实践站' },
              { value: '0314387', label: '孔宁村新时代文明实践站' },
              { value: '03143823', label: '孔贤村新时代文明实践站' }
            ]
          },
          {
            value: '031439',
            label: '市中街道新时代文明实践所',
            children: [
              { value: '031438', label: '渤海村新时代文明实践站' },
              { value: '0314398', label: '阳光村新时代文明实践站' },
              { value: '03143924', label: '云祥村新时代文明实践站' }
            ]
          },
          {
            value: '0314310',
            label: '铁营镇新时代文明实践所',
            children: [
              { value: '031439', label: '六星塬村新时代文明实践站' },
              { value: '03143109', label: '桑庄新村新时代文明实践站' },
              { value: '031431025', label: '郑庙新村新时代文明实践站' }
            ]
          },
          {
            value: '0314311',
            label: '西段乡新时代文明实践所',
            children: [
              { value: '0314310', label: '程王村新时代文明实践站' },
              { value: '031431110', label: '西段新村新时代文明实践站' },
              { value: '031431126', label: '张梁村新时代文明实践站' }
            ]
          },
          {
            value: '0314312',
            label: '杨安镇新时代文明实践所',
            children: [
              { value: '0314311', label: '百味佳新村新时代文明实践站' },
              { value: '031431211', label: '千都苑新村新时代文明实践站' },
              { value: '031431227', label: '颐杨城新村新时代文明实践站' }
            ]
          },
          {
            value: '0314313',
            label: '云红街道新时代文明实践所',
            children: [
              { value: '0314312', label: '千红湖村新时代文明实践站' },
              { value: '031431312', label: '三和村新时代文明实践站' },
              { value: '031431328', label: '忠义村新时代文明实践站' }
            ]
          },
          {
            value: '0314314',
            label: '寨头堡乡新时代文明实践所',
            children: [
              { value: '0314313', label: '和谐村新时代文明实践站' },
              { value: '031431413', label: '永兴村新时代文明实践站' },
              { value: '031431429', label: '中心村新时代文明实践站' }
            ]
          },
          {
            value: '0314315',
            label: '郑店镇新时代文明实践所',
            children: [
              { value: '0314314', label: '光明新村新时代文明实践站' },
              { value: '031431514', label: '河南新村新时代文明实践站' },
              { value: '031431530', label: '郑店新村新时代文明实践站' }
            ]
          },
          {
            value: '0314316',
            label: '朱集镇新时代文明实践所',
            children: [
              { value: '0314315', label: '大徐村新时代文明实践站' },
              { value: '031431615', label: '王玉讲村新时代文明实践站' },
              { value: '031431631', label: '灶户田村新时代文明实践站' }
            ]
          },
          {
            value: '0314317',
            label: '胡家街道新时代文明实践所',
            children: [
              { value: '0314316', label: '胡家新村新时代文明实践站' },
              { value: '031431716', label: '赵木匠新村新时代文明实践站' },
              { value: '031431732', label: '王起新村新时代文明实践站' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '04',
    label: '临邑县',
    children: [
      {
        value: '04154',
        label: '临邑县新时代文明实践中心',
        children: [
          {
            value: '041542',
            label: '德平镇新时代文明实践所',
            children: [
              { value: '041541', label: '郭杨新村新时代文明实践站' },
              { value: '0415421', label: '三联庙村新时代文明实践站' },
              { value: '04154213', label: '茄子李村新时代文明实践站' }
            ]
          },
          {
            value: '041543',
            label: '恒源街道新时代文明实践所',
            children: [
              { value: '041542', label: '刘波海村新时代文明实践站' },
              { value: '0415432', label: '后仓新村新时代文明实践站' },
              { value: '04154314', label: '后八里村新时代文明实践站' }
            ]
          },
          {
            value: '041544',
            label: '理合务镇新时代文明实践所',
            children: [
              { value: '041543', label: '林寨村新时代文明实践站' },
              { value: '0415443', label: '孙镇村新时代文明实践站' },
              { value: '04154415', label: '尹家村新时代文明实践站' }
            ]
          },
          {
            value: '041545',
            label: '林子镇新时代文明实践所',
            children: [
              { value: '041544', label: '双兴村新时代文明实践站' },
              { value: '0415454', label: '河畔新村新时代文明实践站' },
              { value: '04154516', label: '刘北辰村新时代文明实践站' }
            ]
          },
          {
            value: '041546',
            label: '临南镇新时代文明实践所',
            children: [
              { value: '041545', label: '张站吴村新时代文明实践站' },
              { value: '0415465', label: '同心新村新时代文明实践站' },
              { value: '04154617', label: '宋洼庄村新时代文明实践站' }
            ]
          },
          {
            value: '041547',
            label: '临盘街道新时代文明实践所',
            children: [
              { value: '041546', label: '门刘新村新时代文明实践站' },
              { value: '0415476', label: '辛集新村新时代文明实践站' },
              { value: '04154718', label: '刘庙新村新时代文明实践站' }
            ]
          },
          {
            value: '041548',
            label: '临邑镇新时代文明实践所',
            children: [
              { value: '041547', label: '朱家胡同村新时代文明实践站' },
              { value: '0415487', label: '李仙台联合新村新时代文明实践站' },
              { value: '04154819', label: '刘道行村新时代文明实践站' }
            ]
          },
          {
            value: '041549',
            label: '孟寺镇新时代文明实践所',
            children: [
              { value: '041548', label: '昝家村新时代文明实践站' },
              { value: '0415498', label: '赵家村新时代文明实践站' },
              { value: '04154920', label: '袁姚村新时代文明实践站' }
            ]
          },
          {
            value: '0415410',
            label: '邢侗街道新时代文明实践所',
            children: [
              { value: '041549', label: '开元新村新时代文明实践站' },
              { value: '04154109', label: '同昶新村新时代文明实践站' },
              { value: '041541021', label: '同曦新村新时代文明实践站' }
            ]
          },
          {
            value: '0415411',
            label: '兴隆镇新时代文明实践所',
            children: [
              { value: '0415410', label: '夏三屯村新时代文明实践站' },
              { value: '041541110', label: '前寨村新时代文明实践站' },
              { value: '041541122', label: '郭集村新时代文明实践站' }
            ]
          },
          {
            value: '0415412',
            label: '宿安乡新时代文明实践所',
            children: [
              { value: '0415411', label: '幸福新村新时代文明实践站' },
              { value: '041541211', label: '陶家寨村新时代文明实践站' },
              { value: '041541223', label: '夏家村新时代文明实践站' }
            ]
          },
          {
            value: '0415413',
            label: '翟家镇新时代文明实践所',
            children: [
              { value: '0415412', label: '宫家新村新时代文明实践站' },
              { value: '041541312', label: '赵家村新时代文明实践站' },
              { value: '041541324', label: '郑家湾村新时代文明实践站' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '05',
    label: '陵城区',
    children: [
      {
        value: '05165',
        label: '陵城区新时代文明实践中心',
        children: [
          {
            value: '051652',
            label: '安德街道新时代文明实践所',
            children: [
              { value: '051651', label: '芦坊社区新时代文明实践站' },
              { value: '0516521', label: '时楼村新时代文明实践站' },
              { value: '05165214', label: '紫云社区新时代文明实践站' }
            ]
          },
          {
            value: '051653',
            label: '边临镇新时代文明实践所',
            children: [
              { value: '051652', label: '西于架村新时代文明实践站' },
              { value: '0516532', label: '边临镇街村新时代文明实践站' },
              { value: '05165315', label: '库庄村新时代文明实践站' }
            ]
          },
          {
            value: '051654',
            label: '丁庄镇新时代文明实践所',
            children: [
              { value: '051653', label: '丁庄新村新时代文明实践站' },
              { value: '0516543', label: '孙堤口村新时代文明实践站' },
              { value: '05165416', label: '闫庄村新时代文明实践站' }
            ]
          },
          {
            value: '051655',
            label: '徽王庄镇新时代文明实践所',
            children: [
              { value: '051654', label: '玫瑰园新村新时代文明实践站' },
              { value: '0516554', label: '大官辛村新时代文明实践站' },
              { value: '05165517', label: '西纸坊村新时代文明实践站' }
            ]
          },
          {
            value: '051656',
            label: '临齐街道新时代文明实践所',
            children: [
              { value: '051655', label: '马酒坊村新时代文明实践站' },
              { value: '0516565', label: '前张机村新时代文明实践站' },
              { value: '05165618', label: '五李社区新时代文明实践站' }
            ]
          },
          {
            value: '051657',
            label: '糜镇新时代文明实践所',
            children: [
              { value: '051656', label: '解孟村新时代文明实践站' },
              { value: '0516576', label: '陈凡村新时代文明实践站' },
              { value: '05165719', label: '崔赵村新时代文明实践站' }
            ]
          },
          {
            value: '051658',
            label: '前孙镇新时代文明实践所',
            children: [
              { value: '051657', label: '张架村新时代文明实践站' },
              { value: '0516587', label: '百万新村新时代文明实践站' },
              { value: '05165820', label: '翟庄村新时代文明实践站' }
            ]
          },
          {
            value: '051659',
            label: '神头镇新时代文明实践所',
            children: [
              { value: '051658', label: '西郭村新时代文明实践站' },
              { value: '0516598', label: '九合聚村新时代文明实践站' },
              { value: '05165921', label: '南郭村新时代文明实践站' }
            ]
          },
          {
            value: '0516510',
            label: '宋家镇新时代文明实践所',
            children: [
              { value: '051659', label: '高牛村新时代文明实践站' },
              { value: '05165109', label: '王集新村新时代文明实践站' },
              { value: '051651022', label: '小林村新时代文明实践站' }
            ]
          },
          {
            value: '0516511',
            label: '义渡口镇新时代文明实践所',
            children: [
              { value: '0516510', label: '北小高村新时代文明实践站' },
              { value: '051651110', label: '毛李村新时代文明实践站' },
              { value: '051651123', label: '解家村新时代文明实践站' }
            ]
          },
          {
            value: '0516512',
            label: '于集乡新时代文明实践所',
            children: [
              { value: '0516511', label: '程屯村新时代文明实践站' },
              { value: '051651211', label: '谭庄村新时代文明实践站' },
              { value: '051651224', label: '孟家村新时代文明实践站' }
            ]
          },
          {
            value: '0516513',
            label: '郑家寨镇新时代文明实践所',
            children: [
              { value: '0516512', label: '李五清村新时代文明实践站' },
              { value: '051651312', label: '祝家新村新时代文明实践站' },
              { value: '051651325', label: '栾家村新时代文明实践站' }
            ]
          },
          {
            value: '0516514',
            label: '滋镇新时代文明实践所',
            children: [
              { value: '0516513', label: '张耀龙村新时代文明实践站' },
              { value: '051651413', label: '三洄河村新时代文明实践站' },
              { value: '051651426', label: '宋杨村新时代文明实践站' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '06',
    label: '宁津县',
    children: [
      {
        value: '06176',
        label: '宁津县新时代文明实践中心',
        children: [
          {
            value: '061762',
            label: '柴胡店镇新时代文明实践所',
            children: [
              { value: '061761', label: '崔杨村新时代文明实践站' },
              { value: '0617621', label: '鲍权家村新时代文明实践站' },
              { value: '06176213', label: '柴庙村新时代文明实践站' }
            ]
          },
          {
            value: '061763',
            label: '大曹镇新时代文明实践所',
            children: [
              { value: '061762', label: '董黄李村新时代文明实践站' },
              { value: '0617632', label: '大曹村新时代文明实践站' },
              { value: '06176314', label: '邢王张村新时代文明实践站' }
            ]
          },
          {
            value: '061764',
            label: '大柳镇新时代文明实践所',
            children: [
              { value: '061763', label: '五湖村新时代文明实践站' },
              { value: '0617643', label: '双进村新时代文明实践站' },
              { value: '06176415', label: '小章村新时代文明实践站' }
            ]
          },
          {
            value: '061765',
            label: '杜集镇新时代文明实践所',
            children: [
              { value: '061764', label: '常洼村新时代文明实践站' },
              { value: '0617654', label: '肖庄村新时代文明实践站' },
              { value: '06176516', label: '姜庄村新时代文明实践站' }
            ]
          },
          {
            value: '061766',
            label: '津城街道新时代文明实践所',
            children: [
              { value: '061765', label: '德尚新村新时代文明实践站' },
              { value: '0617665', label: '百佛堂村新时代文明实践站' },
              { value: '06176617', label: '新合新村新时代文明实践站' }
            ]
          },
          {
            value: '061767',
            label: '刘营伍乡新时代文明实践所',
            children: [
              { value: '061766', label: '刘营伍村新时代文明实践站' },
              { value: '0617676', label: '商庄村新时代文明实践站' },
              { value: '06176718', label: '于庄村新时代文明实践站' }
            ]
          },
          {
            value: '061768',
            label: '宁城街道新时代文明实践所',
            children: [
              { value: '061767', label: '福宁社区新时代文明实践站' },
              { value: '0617687', label: '康宁社区新时代文明实践站' },
              { value: '06176819', label: '宁城街道安业社区新时代文明实践站' }
            ]
          },
          {
            value: '061769',
            label: '时集镇新时代文明实践所',
            children: [
              { value: '061768', label: '时集村新时代文明实践站' },
              { value: '0617698', label: '盖庄村新时代文明实践站' },
              { value: '06176920', label: '虎西村新时代文明实践站' }
            ]
          },
          {
            value: '0617610',
            label: '相衙镇新时代文明实践所',
            children: [
              { value: '061769', label: '大耿村新时代文明实践站' },
              { value: '06176109', label: '化牛李村新时代文明实践站' },
              { value: '061761021', label: '杨于新村新时代文明实践站' }
            ]
          },
          {
            value: '0617611',
            label: '张大庄镇新时代文明实践所',
            children: [
              { value: '0617610', label: '双郑马村新时代文明实践站' },
              { value: '061761110', label: '张刘房村新时代文明实践站' },
              { value: '061761122', label: '前徐村新时代文明实践站' }
            ]
          },
          {
            value: '0617612',
            label: '长官镇新时代文明实践所',
            children: [
              { value: '0617611', label: '桑庄村新时代文明实践站' },
              { value: '061761211', label: '张凤巢村新时代文明实践站' },
              { value: '061761223', label: '黄庄村新时代文明实践站' }
            ]
          },
          {
            value: '0617613',
            label: '保店镇新时代文明实践所',
            children: [
              { value: '0617612', label: '黄镇村新时代文明实践站' },
              { value: '061761312', label: '孙庄村新时代文明实践站' },
              { value: '061761324', label: '庞庄村新时代文明实践站' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '07',
    label: '平原县',
    children: [
      {
        value: '07187',
        label: '平原县新时代文明实践中心',
        children: [
          {
            value: '071872',
            label: '德原街道新时代文明实践所',
            children: [
              { value: '071871', label: '叶庄村新时代文明实践站' },
              { value: '0718721', label: '庞张村新时代文明实践站' },
              { value: '07187213', label: '德坊村新时代文明实践站' }
            ]
          },
          {
            value: '071873',
            label: '恩城镇新时代文明实践所',
            children: [
              { value: '071872', label: '陈营村新时代文明实践站' },
              { value: '0718732', label: '耿庄新时代文明实践站' },
              { value: '07187314', label: '西四街新时代文明实践站' }
            ]
          },
          {
            value: '071874',
            label: '龙门街道新时代文明实践所',
            children: [
              { value: '071873', label: '军仓新村新时代文明实践站' },
              { value: '0718743', label: '炉坊新时代文明实践站' },
              { value: '07187415', label: '刘庄新时代文明实践站' }
            ]
          },
          {
            value: '071875',
            label: '前曹镇新时代文明实践所',
            children: [
              { value: '071874', label: '西马庄村新时代文明实践站' },
              { value: '0718754', label: '河东村新时代文明实践站' },
              { value: '07187516', label: '祝庄村新时代文明实践站' }
            ]
          },
          {
            value: '071876',
            label: '三唐乡新时代文明实践所',
            children: [
              { value: '071875', label: '中兴村（原矫庄）新时代文明实践站' },
              { value: '0718765', label: '兴旺村新时代文明实践站' },
              { value: '07187617', label: '祥和村新时代文明实践站' }
            ]
          },
          {
            value: '071877',
            label: '桃园街道新时代文明实践所',
            children: [
              { value: '071876', label: '李勇村（原前勇村）新时代文明实践站' },
              {
                value: '0718776',
                label: '七里屯（原后七里屯）新时代文明实践站'
              },
              { value: '07187718', label: '卜庄新时代文明实践站' }
            ]
          },
          {
            value: '071878',
            label: '王打卦镇新时代文明实践所',
            children: [
              { value: '071877', label: '众和村（原南刘村）新时代文明实践站' },
              { value: '0718787', label: '领航新村新时代文明实践站' },
              { value: '07187819', label: '东屯村新时代文明实践站' }
            ]
          },
          {
            value: '071879',
            label: '王凤楼镇新时代文明实践所',
            children: [
              { value: '071878', label: '柴家庙村新时代文明实践站' },
              { value: '0718798', label: '高庄新时代文明实践站' },
              { value: '07187920', label: '于姚村新时代文明实践站' }
            ]
          },
          {
            value: '0718710',
            label: '王杲铺镇新时代文明实践所',
            children: [
              { value: '071879', label: '邢博泉村新时代文明实践站' },
              { value: '07187109', label: '洼董村新时代文明实践站' },
              { value: '071871021', label: '曹庄村新时代文明实践站' }
            ]
          },
          {
            value: '0718711',
            label: '王庙镇新时代文明实践所',
            children: [
              { value: '0718710', label: '孙庄村新时代文明实践站' },
              { value: '071871110', label: '辛屯村新时代文明实践站' },
              { value: '071871122', label: '双兴村新时代文明实践站' }
            ]
          },
          {
            value: '0718712',
            label: '腰站镇新时代文明实践所',
            children: [
              { value: '0718711', label: '红源村(原小屯村）新时代文明实践站' },
              { value: '071871211', label: '堂槐村新时代文明实践站' },
              { value: '071871223', label: '阚辛村新时代文明实践站' }
            ]
          },
          {
            value: '0718713',
            label: '张华镇新时代文明实践所',
            children: [
              { value: '0718712', label: '盆吴村新时代文明实践站' },
              { value: '071871312', label: '大陈村新时代文明实践站' },
              { value: '071871324', label: '梨园村新时代文明实践站' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '08',
    label: '齐河县',
    children: [
      {
        value: '08198',
        label: '齐河县新时代文明实践中心',
        children: [
          {
            value: '081982',
            label: '安头乡新时代文明实践所',
            children: [
              { value: '081981', label: '冢子村村新时代文明实践站' },
              { value: '0819821', label: '西里仁村新时代文明实践站' },
              { value: '08198216', label: '张孟杨村时代文明实践站' }
            ]
          },
          {
            value: '081983',
            label: '表白寺镇新时代文明实践所',
            children: [
              { value: '081982', label: '谭家村新时代文明实践站' },
              { value: '0819832', label: '崔许村新时代文明实践站' },
              { value: '08198317', label: '后杨村新时代文明实践站' }
            ]
          },
          {
            value: '081984',
            label: '大黄乡新时代文明实践所',
            children: [
              { value: '081983', label: '大张村新时代文明实践站' },
              { value: '0819843', label: '仓上村新时代文明实践站' },
              { value: '08198418', label: '王洪屯村新时代文明实践站' }
            ]
          },
          {
            value: '081985',
            label: '胡官屯镇新时代文明实践所',
            children: [
              { value: '081984', label: '沙张村新时代文明实践站' },
              { value: '0819854', label: '陶庄村新时代文明实践站' },
              { value: '08198519', label: '姬庄村新时代文明实践站' }
            ]
          },
          {
            value: '081986',
            label: '华店镇新时代文明实践所',
            children: [
              { value: '081985', label: '三堂村新时代文明实践站' },
              { value: '0819865', label: '韩辛村新时代文明实践站' },
              { value: '08198620', label: '滕庄村新时代文明实践站' }
            ]
          },
          {
            value: '081987',
            label: '焦庙镇新时代文明实践所',
            children: [
              { value: '081986', label: '曹虎村新时代文明实践站' },
              { value: '0819876', label: '黄屯村新时代文明实践站' },
              { value: '08198721', label: '赵官屯村新时代文明实践站' }
            ]
          },
          {
            value: '081988',
            label: '刘桥镇新时代文明实践所',
            children: [
              { value: '081987', label: '西杨村新时代文明实践站' },
              { value: '0819887', label: '赵庄村新时代文明实践站' },
              { value: '08198822', label: '孟店村新时代文明实践站' }
            ]
          },
          {
            value: '081989',
            label: '马集镇新时代文明实践所',
            children: [
              { value: '081988', label: '杨庄村新时代文明实践站' },
              { value: '0819898', label: '小辛村新时代文明实践站' },
              { value: '08198923', label: '顾道口村新时代文明实践站' }
            ]
          },
          {
            value: '0819810',
            label: '潘店镇新时代文明实践所',
            children: [
              { value: '081989', label: '西赵村新时代文明实践站' },
              { value: '08198109', label: '王显武村新时代文明实践站' },
              { value: '081981024', label: '北段村新时代文明实践站' }
            ]
          },
          {
            value: '0819811',
            label: '仁里集镇新时代文明实践所',
            children: [
              { value: '0819810', label: '韩胡村新时代文明实践站' },
              { value: '081981110', label: '翟寺村新时代文明实践站' },
              { value: '081981125', label: '南张村新时代文明实践站' }
            ]
          },
          {
            value: '0819812',
            label: '宣章镇新时代文明实践所',
            children: [
              { value: '0819811', label: '宋庄村新时代文明实践站' },
              { value: '081981211', label: '小吕村新时代文明实践站' },
              { value: '081981226', label: '范桥村新时代文明实践站' }
            ]
          },
          {
            value: '0819813',
            label: '晏北街道新时代文明实践所',
            children: [
              { value: '0819812', label: '柳杭村新时代文明实践站' },
              { value: '081981312', label: '瓦宋村新时代文明实践站' },
              { value: '081981327', label: '葛庄村新时代文明实践站' }
            ]
          },
          {
            value: '0819814',
            label: '晏城街道新时代文明实践所',
            children: [
              { value: '0819813', label: '大魏村新时代文明实践站' },
              { value: '081981413', label: '晏城街村新时代文明实践站' },
              { value: '081981428', label: '小王村新时代文明实践站' }
            ]
          },
          {
            value: '0819815',
            label: '赵官镇新时代文明实践所',
            children: [
              { value: '0819814', label: '付庄村新时代文明实践站' },
              { value: '081981514', label: '于宅子村新时代文明实践站' },
              { value: '081981529', label: '南何村新时代文明实践站' }
            ]
          },
          {
            value: '0819816',
            label: '祝阿镇新时代文明实践所',
            children: [
              { value: '0819815', label: '高屯村新时代文明实践站' },
              { value: '081981615', label: '石屯村新时代文明实践站' },
              { value: '081981630', label: '小朱村新时代文明实践站' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '09',
    label: '庆云县',
    children: [
      {
        value: '091109',
        label: '庆云县新时代文明实践中心',
        children: [
          {
            value: '0911092',
            label: '渤海路街道新时代文明实践所',
            children: [
              { value: '0911091', label: '东刘村时代文明实践站' },
              { value: '09110921', label: '齐家村新时代文明实践站' },
              { value: '091109210', label: '养马王村新时代文明实践站' }
            ]
          },
          {
            value: '0911093',
            label: '常家镇新时代文明实践所',
            children: [
              { value: '0911092', label: '小刘村新时代文明实践站' },
              { value: '09110932', label: '北板营村新时代文明实践站' },
              { value: '091109311', label: '南板营村新时代文明实践站' }
            ]
          },
          {
            value: '0911094',
            label: '崔口镇新时代文明实践所',
            children: [
              { value: '0911093', label: '周辛村新时代文明实践站' },
              { value: '09110943', label: '前程赵村新时代文明实践站' },
              { value: '091109412', label: '一屯村新时代文明实践站' }
            ]
          },
          {
            value: '0911095',
            label: '东辛店镇新时代文明实践所',
            children: [
              { value: '0911094', label: '志门刘村新时代文明实践站' },
              { value: '09110954', label: '万粮张村新时代文明实践站' },
              { value: '091109513', label: '汾水马村新时代文明实践站' }
            ]
          },
          {
            value: '0911096',
            label: '庆云镇新时代文明实践所',
            children: [
              { value: '0911095', label: '张桃符村新时代文明实践站' },
              { value: '09110965', label: '陈瑞芝村新时代文明实践站' },
              { value: '091109614', label: '韩家村新时代文明实践站' }
            ]
          },
          {
            value: '0911097',
            label: '尚堂镇新时代文明实践所',
            children: [
              { value: '0911096', label: '南侯村新时代文明实践站' },
              { value: '09110976', label: '颊河徐村新时代文明实践站' },
              { value: '091109715', label: '郑家村新时代文明实践站' }
            ]
          },
          {
            value: '0911098',
            label: '徐园子乡新时代文明实践所',
            children: [
              { value: '0911097', label: '巴古村新时代文明实践站' },
              { value: '09110987', label: '黄道口村新时代文明实践站' },
              { value: '091109816', label: '周家村新时代文明实践站' }
            ]
          },
          {
            value: '0911099',
            label: '严务乡新时代文明实践所',
            children: [
              { value: '0911098', label: '冯桥村新时代文明实践站' },
              { value: '09110998', label: '严务村新时代文明实践站' },
              { value: '091109917', label: '张辛村新时代文明实践站' }
            ]
          },
          {
            value: '09110910',
            label: '中丁乡新时代文明实践所',
            children: [
              { value: '0911099', label: '堤南刘村新时代文明实践站' },
              { value: '091109109', label: '杨和寺村新时代文明实践站' },
              { value: '0911091018', label: '刘秦辛村新时代文明实践站' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '010',
    label: '武城县',
    children: [
      {
        value: '01011110',
        label: '武城县新时代文明实践中心',
        children: [
          {
            value: '010111102',
            label: '鲁权屯镇新时代文明实践所',
            children: [
              { value: '010111101', label: '宋王庄村新时代文明实践站' },
              { value: '0101111021', label: '张官屯村新时代文明实践站' },
              { value: '0101111029', label: '第十屯村新时代文明实践站' }
            ]
          },
          {
            value: '010111103',
            label: '武城镇新时代文明实践所',
            children: [
              { value: '010111102', label: '肖邢王庄村新时代文明实践站' },
              { value: '0101111032', label: '南北官庄村新时代文明实践站' },
              { value: '01011110310', label: '东七里庄村新时代文明实践站' }
            ]
          },
          {
            value: '010111104',
            label: '老城镇新时代文明实践所',
            children: [
              { value: '010111103', label: '小王庄村新时代文明实践站' },
              { value: '0101111043', label: '南关村新时代文明实践站' },
              { value: '01011110411', label: '东徐村新时代文明实践站' }
            ]
          },
          {
            value: '010111105',
            label: '郝王庄镇新时代文明实践所',
            children: [
              { value: '010111104', label: '草一村新时代文明实践站' },
              { value: '0101111054', label: '李古寺村新时代文明实践站' },
              { value: '01011110512', label: '大祁庄村新时代文明实践站' }
            ]
          },
          {
            value: '010111106',
            label: '甲马营镇新时代文明实践所',
            children: [
              { value: '010111105', label: '北王庄村新时代文明实践站' },
              { value: '0101111065', label: '七机营村新时代文明实践站' },
              { value: '01011110613', label: '田庄村新时代文明实践站' }
            ]
          },
          {
            value: '010111107',
            label: '四女寺镇新时代文明实践所',
            children: [
              { value: '010111106', label: '白庄村新时代文明实践站' },
              { value: '0101111076', label: '李庄村新时代文明实践站' },
              { value: '01011110714', label: '西礼义庄村新时代文明实践站' }
            ]
          },
          {
            value: '010111108',
            label: '李家户镇新时代文明实践所',
            children: [
              { value: '010111107', label: '西店村新时代文明实践站' },
              { value: '0101111087', label: '东升村新时代文明实践站' },
              { value: '01011110815', label: '王家户村新时代文明实践站' }
            ]
          },
          {
            value: '010111109',
            label: '广运街道新时代文明实践所',
            children: [
              { value: '010111108', label: '后王立屯村新时代文明实践站' },
              { value: '0101111098', label: '高庄村新时代文明实践站' },
              { value: '01011110916', label: '军庄村新时代文明实践站' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '011',
    label: '夏津县',
    children: [
      {
        value: '01111211',
        label: '夏津县新时代文明实践中心',
        children: [
          {
            value: '011112112',
            label: '白马湖镇新时代文明实践所',
            children: [
              { value: '011112111', label: '陈庄村村新时代文明实践站' },
              { value: '0111121121', label: '枣林村新时代文明实践站' },
              { value: '01111211215', label: '西梁村新时代文明实践站' }
            ]
          },
          {
            value: '011112113',
            label: '北城街道新时代文明实践所',
            children: [
              { value: '011112112', label: '胡里长屯村新时代文明实践站' },
              { value: '0111121132', label: '五里庄村新时代文明实践站' },
              { value: '01111211316', label: '杨堤村新时代文明实践站' }
            ]
          },
          {
            value: '011112114',
            label: '东李官屯镇新时代文明实践所',
            children: [
              { value: '011112113', label: '段庄村新时代文明实践站' },
              { value: '0111121143', label: '邹庄村村新时代文明实践站' },
              { value: '01111211417', label: '贺屯村新时代文明实践站' }
            ]
          },
          {
            value: '011112115',
            label: '渡口驿乡新时代文明实践所',
            children: [
              { value: '011112114', label: '东渡口驿村新时代文明实践站' },
              { value: '0111121154', label: '西刘堤村新时代文明实践站' },
              { value: '01111211518', label: '季王庄村新时代文明实践站' }
            ]
          },
          {
            value: '011112116',
            label: '雷集镇新时代文明实践所',
            children: [
              { value: '011112115', label: '甜水庄村新时代文明实践站' },
              { value: '0111121165', label: '马官屯村新时代文明实践站' },
              { value: '01111211619', label: '张集村新时代文明实践站' }
            ]
          },
          {
            value: '011112117',
            label: '南城镇新时代文明实践所',
            children: [
              { value: '011112116', label: '别坊村新时代文明实践站' },
              { value: '0111121176', label: '地藏寺村新时代文明实践站' },
              { value: '01111211720', label: '刘庄村新时代文明实践站' }
            ]
          },
          {
            value: '011112118',
            label: '双庙镇新时代文明实践所',
            children: [
              { value: '011112117', label: '王堂村新时代文明实践站' },
              { value: '0111121187', label: '崔庄村新时代文明实践站' },
              { value: '01111211821', label: '小于庄村新时代文明实践站' }
            ]
          },
          {
            value: '011112119',
            label: '宋楼镇新时代文明实践所',
            children: [
              { value: '011112118', label: '赵官屯村新时代文明实践站' },
              { value: '0111121198', label: '张堤村新时代文明实践站' },
              { value: '01111211922', label: '前王沟村新时代文明实践站' }
            ]
          },
          {
            value: '0111121110',
            label: '苏留庄镇新时代文明实践所',
            children: [
              { value: '011112119', label: '石庄村新时代文明实践站' },
              { value: '01111211109', label: '东韩村新时代文明实践站' },
              { value: '011112111023', label: '任庄村新时代文明实践站' }
            ]
          },
          {
            value: '0111121111',
            label: '田庄乡新时代文明实践所',
            children: [
              { value: '0111121110', label: '张堡村新时代文明实践站' },
              { value: '011112111110', label: '八方塔村新时代文明实践站' },
              { value: '011112111124', label: '阎庙村新时代文明实践站' }
            ]
          },
          {
            value: '0111121112',
            label: '香赵庄镇新时代文明实践所',
            children: [
              { value: '0111121111', label: '打帘王村新时代文明实践站' },
              { value: '011112111211', label: '王曲庄村新时代文明实践站' },
              { value: '011112111225', label: '王寨村新时代文明实践站' }
            ]
          },
          {
            value: '0111121113',
            label: '新盛店镇新时代文明实践所',
            children: [
              { value: '0111121112', label: '西菜园村新时代文明实践站' },
              { value: '011112111312', label: '珠西村新时代文明实践站' },
              { value: '011112111326', label: '陈屯村新时代文明实践站' }
            ]
          },
          {
            value: '0111121114',
            label: '银城街道新时代文明实践所',
            children: [
              { value: '0111121113', label: '八里庄村新时代文明实践站' },
              { value: '011112111413', label: '淡官屯东村新时代文明实践站' },
              { value: '011112111427', label: '冉庄新时代文明实践站' }
            ]
          },
          {
            value: '0111121115',
            label: '郑保屯镇新时代文明实践所',
            children: [
              { value: '0111121114', label: '七屯村新时代文明实践站' },
              { value: '011112111514', label: '邢庄村新时代文明实践站' },
              { value: '011112111528', label: '杨中村新时代文明实践站' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '012',
    label: '禹城市',
    children: [
      {
        value: '01211312',
        label: '禹城市新时代文明实践中心',
        children: [
          {
            value: '012113122',
            label: '安仁镇新时代文明实践所',
            children: [
              { value: '012113121', label: '冯旺村新时代文明实践站' },
              { value: '0121131221', label: '孟庄村新时代文明实践站' },
              { value: '01211312212', label: '齐尧村新时代文明实践站' }
            ]
          },
          {
            value: '012113123',
            label: '房寺镇新时代文明实践所',
            children: [
              { value: '012113122', label: '房寺街村新时代文明实践站' },
              { value: '0121131232', label: '乐源村新时代文明实践站' },
              { value: '01211312313', label: '张安村新时代文明实践站' }
            ]
          },
          {
            value: '012113124',
            label: '莒镇新时代文明实践所',
            children: [
              { value: '012113123', label: '孙富荣村新时代文明实践站' },
              { value: '0121131243', label: '前将军庙村新时代文明实践站' },
              { value: '01211312414', label: '杨集村新时代文明实践站' }
            ]
          },
          {
            value: '012113125',
            label: '梁家镇新时代文明实践所',
            children: [
              { value: '012113124', label: '大纪村新时代文明实践站' },
              { value: '0121131254', label: '武庄村新时代文明实践站' },
              { value: '01211312515', label: '英王村新时代文明实践站' }
            ]
          },
          {
            value: '012113126',
            label: '伦镇新时代文明实践所',
            children: [
              { value: '012113125', label: '太合村新时代文明实践站' },
              { value: '0121131265', label: '袁营新村新时代文明实践站' },
              { value: '01211312616', label: '台楼村新时代文明实践站' }
            ]
          },
          {
            value: '012113127',
            label: '十里望回族镇新时代文明实践所',
            children: [
              { value: '012113126', label: '前高村新时代文明实践站' },
              { value: '0121131276', label: '方庄村新时代文明实践站' },
              { value: '01211312717', label: '程庄村新时代文明实践站' }
            ]
          },
          {
            value: '012113128',
            label: '市中街道新时代文明实践所',
            children: [
              { value: '012113127', label: '罗庄村新时代文明实践站' },
              { value: '0121131287', label: '尚德新村新时代文明实践站' },
              { value: '01211312818', label: '鑫泉新村新时代文明实践站' }
            ]
          },
          {
            value: '012113129',
            label: '辛店镇新时代文明实践所',
            children: [
              { value: '012113128', label: '李伯新村新时代文明实践站' },
              { value: '0121131298', label: '陈忠村新时代文明实践站' },
              { value: '01211312919', label: '张西尧村新时代文明实践站' }
            ]
          },
          {
            value: '0121131210',
            label: '辛寨镇新时代文明实践所',
            children: [
              { value: '012113129', label: '友谊村新时代文明实践站' },
              { value: '01211312109', label: '向前村新时代文明实践站' },
              { value: '012113121020', label: '振兴村新时代文明实践站' }
            ]
          },
          {
            value: '0121131211',
            label: '禹兴街道新时代文明实践所',
            children: [
              { value: '0121131210', label: '尚务头村新时代文明实践站' },
              { value: '012113121110', label: '石屯于庄村新时代文明实践站' },
              { value: '012113121121', label: '窦庄村新时代文明实践站' }
            ]
          },
          {
            value: '0121131212',
            label: '张庄镇新时代文明实践所',
            children: [
              { value: '0121131211', label: '振兴新村新时代文明实践站' },
              { value: '012113121211', label: '帽张村新时代文明实践站' },
              { value: '012113121222', label: '大洼王村新时代文明实践站' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '013',
    label: '运河开发区',
    children: [
      {
        value: '01311413',
        label: '运河开发区新时代文明实践中心',
        children: [
          {
            value: '013114132',
            label: '抬头寺镇新时代文明实践所',
            children: [
              { value: '013114131', label: '满文白村新时代文明实践站' },
              { value: '0131141321', label: '渠庄村新时代文明实践站' },
              { value: '0131141323', label: '杨胡店村新时代文明实践站' }
            ]
          },
          {
            value: '013114133',
            label: '赵虎镇新时代文明实践所',
            children: [
              { value: '013114132', label: '姜庄村新时代文明实践站' },
              { value: '0131141332', label: '吕庄村新时代文明实践站' },
              { value: '0131141334', label: '闫王张村新时代文明实践站' }
            ]
          }
        ]
      }
    ]
  }
]
